<template>
  <div
    v-if="showInstallPrompt"
    class="fixed bottom-4 right-4 z-50 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-4 max-w-sm"
  >
    <div class="flex items-start space-x-3">
      <div class="flex-shrink-0">
        <svg class="w-6 h-6 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      </div>
      <div class="flex-1">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white mb-1">
          Installer l'application
        </h3>
        <p class="text-xs text-gray-600 dark:text-gray-400 mb-3">
          Installez K&C Portfolio Manager pour un accès rapide depuis votre écran d'accueil.
        </p>
        <div class="flex space-x-2">
          <button
            @click="installApp"
            class="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium px-3 py-2 rounded-md transition-colors"
          >
            Installer
          </button>
          <button
            @click="dismissPrompt"
            class="px-3 py-2 text-xs font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            Plus tard
          </button>
        </div>
      </div>
      <button
        @click="dismissPrompt"
        class="flex-shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
      >
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const showInstallPrompt = ref(false)
let deferredPrompt = null

onMounted(() => {
  // Vérifier si l'app est déjà installée
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return
  }

  // Écouter l'événement beforeinstallprompt
  window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
  
  // Vérifier si l'utilisateur a déjà rejeté la proposition
  const dismissed = localStorage.getItem('pwa-install-dismissed')
  if (!dismissed) {
    // Attendre un peu avant d'afficher le prompt
    setTimeout(() => {
      if (deferredPrompt) {
        showInstallPrompt.value = true
      }
    }, 3000) // Afficher après 3 secondes
  }
})

onUnmounted(() => {
  window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
})

function handleBeforeInstallPrompt(e) {
  // Empêcher le prompt par défaut du navigateur
  e.preventDefault()
  // Stocker l'événement pour l'utiliser plus tard
  deferredPrompt = e
}

function installApp() {
  if (!deferredPrompt) {
    return
  }

  // Afficher le prompt d'installation
  deferredPrompt.prompt()

  // Attendre la réponse de l'utilisateur
  deferredPrompt.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === 'accepted') {
      console.log('Utilisateur a accepté l\'installation PWA')
    } else {
      console.log('Utilisateur a rejeté l\'installation PWA')
    }
    // Réinitialiser
    deferredPrompt = null
    showInstallPrompt.value = false
  })
}

function dismissPrompt() {
  showInstallPrompt.value = false
  // Se souvenir que l'utilisateur a rejeté (pendant 7 jours)
  localStorage.setItem('pwa-install-dismissed', Date.now().toString())
  
  // Réinitialiser après 7 jours
  setTimeout(() => {
    localStorage.removeItem('pwa-install-dismissed')
  }, 7 * 24 * 60 * 60 * 1000)
}
</script>

